import api from "./API";
import {Housemate} from "../Types/Housemate";

export type ClaimSubmissionTemplate = {
    amount: number;
    reason: string;
    payeeAccount: string;
}

export type ClaimTemplate = {
    id: number;
    requestedBy: Housemate;
    amount: number;
    reason: string;
}

export default async function getClaims(): Promise<ClaimTemplate[]> {
    try {
        const response = await api.get("/api/unihouse/get/claims");
        return response.data.map((claim: any): ClaimTemplate => ({
            id: claim.id,
            requestedBy: JSON.parse(claim.requestedBy),
            amount: claim.amount,
            reason: claim.reason,
        }));
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function createClaim(claim: ClaimSubmissionTemplate): Promise<void> {
    try {
        await api.put("/api/unihouse/create/claim", claim);
        return;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function deleteClaim(claimId: number): Promise<void> {
    try {
        await api.delete("/api/unihouse/delete/claim?id=" + claimId);
        return;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function submitClaim(claimId: number): Promise<void> {
    try {
        await api.post("/api/account/submit/claim/" + claimId);
        return;
    } catch (error) {
        console.error(error);
        throw error;
    }
}